import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { MdAdd, MdDelete, MdStar } from "react-icons/md";
import CSat from "./CSat";

export const QuestionSection = ({
  language,
  questionData,
  getQuestionType,
  errors,
  touched,
  handleChange,
  setFieldValue,
  prefix,
  sharedAnswerHandler,
  addStatementInOtherForm,
  removeStatementInOtherForm,
  values,
}) => {
  const options = questionData?.options || {};
  const question = questionData?.question || "";
  const answer = questionData?.answer || "";
  const solution = questionData?.solution || "";
  const statements = questionData?.statements || [""];
  const pairData = questionData?.pairs || [];

  const handleAddStatement = () => {
    const updatedStatements = [...statements, ""];
    setFieldValue(`${prefix}.statements`, updatedStatements);
    addStatementInOtherForm(prefix);
  };

  const handleRemoveStatement = (index) => {
    const updatedStatements = statements.filter((_, idx) => idx !== index);
    setFieldValue(`${prefix}.statements`, updatedStatements);
    removeStatementInOtherForm(prefix, index);
  };
  const handleStatementChange = (index, value) => {
    const updatedStatements = [...statements];
    updatedStatements[index] = value;
    setFieldValue(`${prefix}.statements`, updatedStatements);
  };

  const handleAddRow = () => {
    const newRow = Object.keys(pairData[0]).reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {});
    const updatedEnglishPairs = [
      ...values.englishQuestion.pairs,
      { ...newRow },
    ];
    const updatedHindiPairs = [...values.hindiQuestion.pairs, { ...newRow }];
    setFieldValue("englishQuestion.pairs", updatedEnglishPairs);
    setFieldValue("hindiQuestion.pairs", updatedHindiPairs);
  };
  const handleAddColumn = () => {
    const newColumnName = `pair${Object.keys(pairData[0]).length + 1}`;
    const updatedEnglishPairs = values.englishQuestion.pairs.map((pair) => ({
      ...pair,
      [newColumnName]: "",
    }));
    const updatedHindiPairs = values.hindiQuestion.pairs.map((pair) => ({
      ...pair,
      [newColumnName]: "",
    }));
    setFieldValue("englishQuestion.pairs", updatedEnglishPairs);
    setFieldValue("hindiQuestion.pairs", updatedHindiPairs);
  };

  const handleRemoveRow = (index) => {
    const updatedEnglishPairs = values.englishQuestion.pairs.filter(
      (_, idx) => idx !== index
    );
    const updatedHindiPairs = values.hindiQuestion.pairs.filter(
      (_, idx) => idx !== index
    );
    setFieldValue("englishQuestion.pairs", updatedEnglishPairs);
    setFieldValue("hindiQuestion.pairs", updatedHindiPairs);
  };

  const handleRemoveColumn = (columnName) => {
    const updatedEnglishPairs = values.englishQuestion.pairs.map((pair) => {
      const { [columnName]: _, ...rest } = pair;
      return rest;
    });
    const updatedHindiPairs = values.hindiQuestion.pairs.map((pair) => {
      const { [columnName]: _, ...rest } = pair;
      return rest;
    });
    setFieldValue("englishQuestion.pairs", updatedEnglishPairs);
    setFieldValue("hindiQuestion.pairs", updatedHindiPairs);
  };

  const handlePairChange = (index, field, value) => {
    if (prefix === "englishQuestion") {
      const updatedPairs = [...values.englishQuestion.pairs];
      updatedPairs[index][field] = value;
      setFieldValue("englishQuestion.pairs", updatedPairs);
    } else if (prefix === "hindiQuestion") {
      const updatedPairs = [...values.hindiQuestion.pairs];
      updatedPairs[index][field] = value;
      setFieldValue("hindiQuestion.pairs", updatedPairs);
    }
  };

  const [filteredSuggestions, setFilteredSuggestions] = useState({});
  const [showSuggestions, setShowSuggestions] = useState({});

  const optionData = {
    english: {
      A: [
        "1 and 2 only",
        "Only one",
        "Only two",
        "Both Statement-I and Statement-II are correct and Statement-II explains Statement-I",
        "Only one",
        "1 only",
        "1 and 2",
        "1, 2 and 3",
        "Both Statement-II and Statement-III are correct and both of them explain Statement-I",
      ],
      B: [
        "2 and 3 only",
        "Only two",
        "Only three",
        "Both Statement-I and Statement-II are correct, but Statement-II does not explain Statement-I",
        "Only two",
        "2 only",
        "2 and 3",
        "1, 2 and 4",
        "Both Statement-II and Statement-III are correct, but only one of them explains Statement-I",
      ],
      C: [
        "1 and 3 only",
        "All three",
        "Only four",
        "Statement-I is correct, but Statement-II is incorrect",
        "Only three",
        "Both 1 and 2",
        "3 and 4",
        "1, 3 and 4",
        "Only one of the Statements II and III is correct and that explains Statement-I",
      ],
      D: [
        "1, 2 and 3",
        "None",
        "All five",
        "Statement-I is incorrect, but Statement-II is correct",
        "All four",
        "Neither 1 nor 2",
        "1 and 4",
        "2, 3 and 4",
        "Neither Statement-II nor Statement-III is correct",
      ],
    },
    hindi: {
      A: [
        "केवल 1 और 2",
        "केवल एक",
        "केवल दो",
        "कथन-I और कथन-II दोनों सही हैं और कथन-II कथन-I की व्याख्या करता है",
        "केवल एक",
        "केवल 1",
        "1 और 2",
        "1, 2 और 3",
        "कथन-II और कथन-III दोनों सही हैं और दोनों कथन-I की व्याख्या करते हैं",
      ],
      B: [
        "केवल 2 और 3",
        "केवल दो",
        "केवल तीन",
        "कथन-I और कथन-II दोनों सही हैं, लेकिन कथन-II कथन-I की व्याख्या नहीं करता है",
        "केवल दो",
        "केवल 2",
        "2 और 3",
        "1, 2 और 4",
        "कथन-II और कथन-III दोनों सही हैं, लेकिन उनमें से केवल एक ही कथन-I की व्याख्या करता है",
      ],
      C: [
        "केवल 1 और 3",
        "सभी तीनों",
        "केवल चार",
        "कथन-I सही है, लेकिन कथन-II गलत है",
        "केवल तीन",
        "1 व 2 दोनों",
        "3 और 4",
        "1, 3 और 4",
        "कथन II और III में से केवल एक ही सही है और वह कथन-I की व्याख्या करता है",
      ],
      D: [
        "1, 2 और 3",
        "कोई नहीं",
        "सभी पाँच",
        "कथन-I गलत है, लेकिन कथन-II सही है",
        "सभी चार",
        "न तो 1 न ही 2",
        "1 और 4",
        "2, 3 और 4",
        "न तो कथन-II न ही कथन-III सही है",
      ],
    },
  };
  const handleInputChange = (e, option) => {
    const userInput = e.target.value;
    setFieldValue(`${prefix}.options.${option}`, userInput);
    const langKey = language === "English" ? "english" : "hindi";
    if (option === "A") {
      const matchingValueIndex = optionData[langKey]["A"].findIndex(
        (item) => item.toLowerCase() === userInput.toLowerCase()
      );
      if (matchingValueIndex !== -1) {
        const bValue = optionData[langKey]["B"][matchingValueIndex];
        const cValue = optionData[langKey]["C"][matchingValueIndex];
        const dValue = optionData[langKey]["D"][matchingValueIndex];

        setFieldValue(`${prefix}.options.B`, bValue);
        setFieldValue(`${prefix}.options.C`, cValue);
        setFieldValue(`${prefix}.options.D`, dValue);
      }
    }
    if (userInput.trim().length > 0) {
      const matches = optionData[langKey][option].filter((item) =>
        item.toLowerCase().includes(userInput.toLowerCase())
      );
      setFilteredSuggestions((prev) => ({
        ...prev,
        [option]: matches,
      }));
      setShowSuggestions((prev) => ({
        ...prev,
        [option]: matches.length > 0,
      }));
    } else {
      setShowSuggestions((prev) => ({
        ...prev,
        [option]: false,
      }));
    }
  };

  const handleSuggestionClick = (option, suggestion) => {
    setFieldValue(`${prefix}.options.${option}`, suggestion);
    setShowSuggestions((prev) => ({
      ...prev,
      [option]: false,
    }));
    const langKey = language === "English" ? "english" : "hindi";
    if (option === "A") {
      const matchingIndex = optionData[langKey]["A"].findIndex(
        (item) => item.toLowerCase() === suggestion.toLowerCase()
      );
      if (matchingIndex !== -1) {
        const bValue = optionData[langKey]["B"][matchingIndex];
        const cValue = optionData[langKey]["C"][matchingIndex];
        const dValue = optionData[langKey]["D"][matchingIndex];
        setFieldValue(`${prefix}.options.B`, bValue);
        setFieldValue(`${prefix}.options.C`, cValue);
        setFieldValue(`${prefix}.options.D`, dValue);
      }
    }
  };

  const handleInputFocus = (option) => {
    const langKey = language === "English" ? "english" : "hindi";
    const matches = optionData[langKey][option];

    setFilteredSuggestions((prev) => ({
      ...prev,
      [option]: matches,
    }));

    setShowSuggestions((prev) => ({
      ...prev,
      [option]: true,
    }));
  };

  const handleInputBlur = (option) => {
    setTimeout(() => {
      setShowSuggestions((prev) => ({
        ...prev,
        [option]: false,
      }));
    }, 200);
  };

  if (getQuestionType === "normal-csat" || getQuestionType === "statement-csat") {
    return <CSat language={language} handleChange={handleChange} prefix={prefix} question={question} touched={touched} errors={errors} getQuestionType={getQuestionType} statements={statements} optionData={optionData} pairData={pairData} showSuggestions={showSuggestions} handleStatementChange={handleStatementChange} handleAddStatement={handleAddStatement} handleRemoveStatement={handleRemoveStatement} handleAddColumn={handleAddColumn} handleRemoveColumn={handleRemoveColumn} handlePairChange={handlePairChange} handleAddRow={handleAddRow} handleRemoveRow={handleRemoveRow} questionData={questionData} values={values} handleInputChange={handleInputChange} handleInputFocus={handleInputFocus} handleInputBlur={handleInputBlur} filteredSuggestions={filteredSuggestions} handleSuggestionClick={handleSuggestionClick} options={options} answer={answer} sharedAnswerHandler={sharedAnswerHandler} solution={solution} setFieldValue={setFieldValue}
    />
  }


  return (
    <div className="py-2 mt-3">
      <div className="mt-4">
        <p className="text-2xl tracking-tight font-semibold text-left text-gray-900 capitalize">
          {language} Question Section
        </p>
        <div className="mt-4">
          <p className="flex items-center capitalize text-lg font-medium text-gray-900">
            Write Question
          </p>
        </div>
      </div>
      <input
        className="border pl-4 border-gray-300 hover:border-gray-300 rounded-md w-full py-2 px-3 text-gray-800 leading-tight outline-none mt-3"
        id="question"
        type="text"
        placeholder={`Enter question (${language})`}
        name={`${prefix}.question`}
        onChange={handleChange}
        value={question}
      />
      {touched?.question && errors?.question && (
        <div className="text-red-600 text-sm mt-2">{errors.question}</div>
      )}
      {(getQuestionType === "statement" || getQuestionType === "statement-csat") && (
        <>
          {statements && (
            <div className="border border-gray-400 mt-4 p-2">
              <p className="flex items-center capitalize text-lg font-medium text-gray-900">
                Statements
              </p>
              <hr className="my-2" />
              {statements.map((statement, index) => (
                <div key={index} className="flex items-center space-x-2 mt-2">
                  <input
                    className="border pl-4 border-gray-300 hover:border-gray-400 rounded-md w-full py-2 px-3 text-gray-800 leading-tight outline-none"
                    type="text"
                    placeholder={`Statement ${index + 1}`}
                    value={statement}
                    onChange={(e) =>
                      handleStatementChange(index, e.target.value)
                    }
                  />
                  <div className="flex sm:mt-0 space-x-2">
                    {index === statements.length - 1 && (
                      <button
                        type="button"
                        onClick={handleAddStatement}
                        className="h-8 w-8 flex justify-center items-center bg-[#124699] text-white rounded-full hover:bg-[#124699]"
                        title="Add Statement"
                      >
                        <MdAdd />
                      </button>
                    )}
                    {index > 0 || statements.length > 1 ? (
                      <button
                        type="button"
                        onClick={() => handleRemoveStatement(index)}
                        className="h-8 w-8 flex justify-center items-center bg-red-500 text-white rounded-full hover:bg-red-600"
                        title="Remove Statement"
                      >
                        <MdDelete />
                      </button>
                    ) : null}
                  </div>
                </div>
              ))}
              {touched?.statements && errors?.statements && (
                <div className="text-red-600 text-sm mt-2">
                  {Array.isArray(errors.statements)
                    ? errors.statements.find(
                      (err, i) => touched.statements[i]
                    ) || errors.statements[0]
                    : errors.statements}
                </div>
              )}
            </div>
          )}
        </>
      )}
      {getQuestionType === "pair" && (
        <div className="mt-4">
          <div className="flex justify-between gap-3">
            <p className="flex items-center capitalize text-lg font-medium text-gray-900">
              Pair Table
            </p>
            <button
              type="button"
              onClick={handleAddColumn}
              className="flex items-center md:px-4 px-2 md:py-2 py-1 text-sm bg-[#124699] text-white rounded-md hover:bg-[#124699]"
            >
              Add Column
            </button>
          </div>
          <div className="overflow-x-auto mt-3">
            <table className="table-auto w-full border-collapse">
              <thead>
                <tr>
                  {pairData.length > 0 &&
                    Object.keys(pairData[0]).map((key, idx) => {
                      if (key !== "question" && key !== "lastQuestion") {
                        return (
                          <th key={idx} className="border p-2">
                            <div className="flex items-center justify-between text-sm gap-2">
                              {key}
                              {Object.keys(pairData[0]).length > 2 && (
                                <CgClose
                                  onClick={() => handleRemoveColumn(key)}
                                  className="cursor-pointer text-red-600"
                                />
                              )}
                            </div>
                          </th>
                        );
                      }
                      return null;
                    })}
                  <th className="border text-sm p-2">A/c</th>
                </tr>
              </thead>
              <tbody>
                {pairData.map((pair, index) => {
                  return (
                    <tr key={index}>
                      {Object.keys(pair).map((key, idx) => {
                        if (key !== "question" && key !== "lastQuestion") {
                          return (
                            <td key={idx} className="border p-2 py-1">
                              <input
                                type="text"
                                value={pair[key]}
                                onChange={(e) =>
                                  handlePairChange(index, key, e.target.value)
                                }
                                className="border w-full py-1 px-2 rounded-md outline-none"
                                placeholder={key}
                              />
                              {errors?.englishQuestion?.pairs?.[index]?.[key] &&
                                touched?.englishQuestion?.pairs?.[index]?.[
                                key
                                ] && (
                                  <div className="text-red-600 text-sm">
                                    {errors.englishQuestion.pairs[index][key]}
                                  </div>
                                )}
                            </td>
                          );
                        }
                        return null;
                      })}
                      <td className="border flex justify-center p-2 gap-2">
                        {index === pairData.length - 1 && (
                          <button
                            type="button"
                            onClick={handleAddRow}
                            className="h-8 w-8 flex justify-center items-center bg-[#124699] text-white rounded-full hover:bg-[#124699]"
                          >
                            <MdAdd />
                          </button>
                        )}
                        {index > 0 || pairData.length > 1 ? (
                          <button
                            type="button"
                            onClick={() => handleRemoveRow(index)}
                            className="h-8 w-8 flex justify-center items-center bg-red-500 text-white rounded-full hover:bg-red-600"
                          >
                            <MdDelete />
                          </button>
                        ) : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {(getQuestionType === "statement" || getQuestionType === "pair" || getQuestionType === "statement-csat") && (
        <div className="mt-4">
          <p className="flex items-center capitalize text-lg font-medium text-gray-900">
            Last Question
          </p>
          <input
            className="border pl-2 text-lg border-gray-400 hover:border-gray-400 rounded-md w-full py-2 px-3 text-gray-800 leading-tight outline-none mt-3"
            id={`${prefix}lastQuestion`}
            type="text"
            placeholder={`Enter statement (${language})`}
            name={`${prefix}.lastQuestion`}
            onChange={handleChange}
            value={questionData?.lastQuestion}
          />
          {touched?.lastQuestion && errors?.lastQuestion && (
            <div className="text-red-600 text-sm mt-2">
              {errors.lastQuestion}
            </div>
          )}
        </div>
      )}

      <div className="md:p-4 p-2 ">
        <p className="flex items-center capitalize text-xl font-medium text-gray-900">
          Options
        </p>
        <div className="grid md:grid-cols-4 grid-cols-2 gap-3 flex-wrap mt-3">
          {Object.keys(optionData.english).map((option) => (
            <div key={option} className="relative">
              <label className="flex mb-2 text-start capitalize text-base font-medium text-gray-700">
                Option - {option}
                <MdStar className="text-[#124699] h-3 w-3" />
              </label>
              <input
                type="text"
                name={`${prefix}.options.${option}`}
                value={values[prefix]?.options?.[option] || ""}
                onChange={(e) => handleInputChange(e, option)}
                onFocus={() => handleInputFocus(option)}
                onBlur={() => handleInputBlur(option)}
                className="block w-full p-2 border rounded-lg bg-white placeholder-gray-400 text-gray-600 border-gray-300 text-sm outline-none"
                placeholder={`Option ${option}`}
              />
              {showSuggestions[option] && (
                <ul className="absolute w-full bg-white border border-gray-300 rounded-md mt-1 shadow-lg z-50">
                  {filteredSuggestions[option].map((item, index) => (
                    <li
                      key={index}
                      className="px-2 cursor-pointer hover:bg-gray-200 line-clamp-1 py-0 mt-2"
                      onClick={() => handleSuggestionClick(option, item)}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="md:p-4 p-2 mt-2">
        <p className="flex items-center capitalize text-xl font-medium text-gray-900">
          Answer
        </p>
        <ul className="grid md:grid-cols-4 grid-cols-2 gap-5 md:gap-x-6 w-full text-sm font-medium text-gray-900 mt-4">
          {Object.keys(options).map((key) => (
            <li key={key}>
              <div className="flex items-center ps-3">
                <input
                  id={`radio${key}`}
                  type="radio"
                  name={`${prefix}.answer`}
                  value={key}
                  checked={answer === key}
                  onChange={(e) => {
                    handleChange(e);
                    sharedAnswerHandler(e.target.value);
                  }}
                  className="w-4 h-4 text-blue-600 border-gray-300 checked:bg-blue-600 checked:outline-none"
                />
                <label
                  htmlFor={`radio${key}`}
                  className="w-full ms-2 text-sm font-medium text-gray-900 line-clamp-1"
                >
                  Option {key}
                </label>
              </div>
            </li>
          ))}
        </ul>
        {touched?.answer && errors?.answer && (
          <div className="text-red-600 text-sm mt-1">{errors.answer}</div>
        )}
      </div>

      <div className="mt-2">
        <p className="flex items-center capitalize text-lg font-medium text-gray-900 mb-2">
          Solution ({language})
        </p>
        <textarea
          id="message"
          rows="20"
          name={`${prefix}.solution`}
          onChange={handleChange}
          value={solution}
          className="border pl-2 text-md border-gray-300 rounded-md w-full min-h-[100px] py-2 px-3 text-gray-800 leading-tight outline-none"
          placeholder={`Enter solution (${language})...`}
        />
        {touched?.solution && errors?.solution && (
          <div className="text-red-600 text-sm">{errors.solution}</div>
        )}
      </div>
    </div>
  );
};

const Normal = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  sharedAnswerHandler,
  addStatementInOtherForm,
  removeStatementInOtherForm,
}) => {
  const getQuestionType = values?.questionType;
  return (
    <div>
      <QuestionSection
        language="English"
        getQuestionType={getQuestionType}
        questionData={values.englishQuestion}
        handleChange={handleChange}
        handleBlur={handleBlur}
        values={values}
        errors={errors?.englishQuestion || {}}
        touched={touched?.englishQuestion || {}}
        setFieldValue={setFieldValue}
        prefix="englishQuestion"
        sharedAnswerHandler={sharedAnswerHandler}
        addStatementInOtherForm={addStatementInOtherForm}
        removeStatementInOtherForm={removeStatementInOtherForm}
      />

      <QuestionSection
        language="Hindi"
        getQuestionType={getQuestionType}
        questionData={values.hindiQuestion}
        handleChange={handleChange}
        handleBlur={handleBlur}
        values={values}
        errors={errors?.hindiQuestion || {}}
        touched={touched?.hindiQuestion || {}}
        setFieldValue={setFieldValue}
        prefix="hindiQuestion"
        sharedAnswerHandler={sharedAnswerHandler}
        addStatementInOtherForm={addStatementInOtherForm}
        removeStatementInOtherForm={removeStatementInOtherForm}
      />
    </div>
  );
};

export default Normal;
